<agpr-autocomplete
    [id]="id"
    [(ngModel)]="selectedAccount"
    [required]="true"
    placeholder="Monitoring.accountPicker.placeholder.generic"
    (itemSelected)="addAccount($event)"
    labelLookupKey="id"
    label="Core.navigation.account"
    [suggestionsFetcher]="copyMentionsToAccountService.searchAccounts.bind(copyMentionsToAccountService)"
    labelField="name"
    [clearOnBlur]="false"
    [multiSelection]="false"
    panelStyleClass="agpr-bulkActionFormAccount-autoCompletePanel"
    selectedItemsHideKey="id"
    [tooltipInfo]="'Monitoring.bulk.action.copyToAccount.account.info'"
    ariaLabelledBy="bulkActionFormAccount_autocompleteLabel_account"
></agpr-autocomplete>

<div class="agpr-bulkActionFormAccount-listSelector"
    [agprLoading]="foldersLoading"
    [loadingSmallIndicator]="true"
>
    <agpr-autocomplete
        [id]="id + '_folders_select_existing'"
        [disabled]="!selectedAccount"
        labelField="name"
        placeholder="Monitoring.folderPicker.placeholder.generic"
        [(ngModel)]="selectedFolder"
        label="Social.saveTool.folder"
        (itemSelected)="folderSelected($event)"
        [customOptions]="customOptions"
        [suggestions]="folderList$"
        [multiSelection]="false"
        [clearOnBlur]="false"
        [dropdown]="true"
        [required]="true"
        panelStyleClass="agpr-bulkActionFormAccount-autoCompletePanel"
        ariaLabelledBy="bulkActionFormAccount_autocompleteLabel_folder"
    ></agpr-autocomplete>
</div>
